module.exports = __webpack_public_path__ + "img/add_logo.8f50226b.svg";